import React from "react";
import { useDispatch, useSelector } from "react-redux";
import config from "../../../../config";
// import { changeLocale } from "@/actions/localization/changeLocale";
import { changeLocale } from "../../../../actions/localization/changeLocale";
import { useTranslation } from "@helpers/translate";
import { BaseDropdown } from "@components/library/UI/BaseDropdown";

import { ReactComponent as UaFlag } from "@assets/images/icons/ua-lang.svg";
import { ReactComponent as EnFlag } from "@assets/images/icons/en-lang.svg";
import { ReactComponent as RuFlag } from "@assets/images/icons/ru-lang.svg";
import { ReactComponent as EsFlag } from "@assets/images/icons/es-lang.svg";

const LANG_FLAGS = {
  ua: UaFlag,
  en: EnFlag,
  ru: RuFlag,
  es: EsFlag,
};

const HeaderGlobeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.475 14.9062C10.8031 16.2719 10.1812 16.5 10 16.5C9.81875 16.5 9.19687 16.2719 8.525 14.9062C7.99375 13.8281 7.6125 12.3562 7.52187 10.75H12.4781C12.3844 12.3594 12.0031 13.8313 11.475 14.9062ZM12.4781 9.25H7.52187C7.61562 7.64062 7.99687 6.16875 8.525 5.09375C9.19687 3.72812 9.81875 3.5 10 3.5C10.1812 3.5 10.8031 3.72812 11.475 5.09375C12.0063 6.17188 12.3875 7.64375 12.4781 9.25ZM13.9812 10.75H16.4562C16.1875 13.0813 14.6844 15.0406 12.6187 15.95C13.3687 14.6125 13.8781 12.75 13.9812 10.75ZM16.4562 9.25H13.9812C13.8781 7.25 13.3687 5.3875 12.6187 4.05C14.6844 4.9625 16.1875 6.91875 16.4562 9.25ZM6.01875 9.25H3.54375C3.8125 6.91875 5.31562 4.95938 7.38125 4.05C6.63125 5.3875 6.12188 7.25 6.01875 9.25ZM3.54375 10.75H6.01875C6.12188 12.75 6.63125 14.6125 7.38125 15.95C5.31562 15.0375 3.8125 13.0813 3.54375 10.75ZM10 18C14.4187 18 18 14.4187 18 10C18 5.58125 14.4187 2 10 2C5.58125 2 2 5.58125 2 10C2 14.4187 5.58125 18 10 18Z"
      fill="#7A7A7A"
    />
  </svg>
);

const LanguageDropdown = ({ variant }) => {
  const dispatch = useDispatch();
  const { locale } = useSelector((state) => state.localization);
  const { __ } = useTranslation();
  const languages = config.supported_locales;
  const Flag = LANG_FLAGS[locale];

  const triggerButton =
    variant === "header" ? (
      <button type="button" className="header__mini-btn">
        <HeaderGlobeIcon />
      </button>
    ) : variant === "mobile-sidebar" ? (
      <button type="button" className="mobile-sidebar__lang-trigger">
        <span className="mobile-sidebar__lang-globe">
          <HeaderGlobeIcon />
        </span>
        <span className="mobile-sidebar__lang-label">
          {__(`settings.lang.${locale}`)}
        </span>
      </button>
    ) : variant === "profile" ? (
      <button
        type="button"
        className="user-profile-dropdown__lang-trigger mobile-sidebar__nav-link"
      >
        <span className="user-profile-dropdown__lang-globe mobile-sidebar__nav-icon">
          <HeaderGlobeIcon />
        </span>
        <span className="user-profile-dropdown__lang-label mobile-sidebar__nav-text">
          {__(`settings.lang.${locale}`)}
        </span>
        <span className="user-profile-dropdown__lang-chevron mobile-sidebar__nav-icon">
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              d="M9.99991 14.1667C9.78658 14.1667 9.57322 14.085 9.41072 13.9225L3.57738 8.0892C3.25155 7.76337 3.25155 7.23665 3.57738 6.91082C3.90322 6.58498 4.42993 6.58498 4.75577 6.91082L9.99991 12.155L15.244 6.91082C15.5699 6.58498 16.0966 6.58498 16.4224 6.91082C16.7483 7.23665 16.7483 7.76337 16.4224 8.0892L10.5891 13.9225C10.4266 14.085 10.2132 14.1667 9.99991 14.1667Z"
              fill="#7A7A7A"
            />
          </svg>
        </span>
      </button>
    ) : (
      <button type="button" className="base-dropdown__button">
        <Flag
          className="language-dropdown__flag"
          style={{ borderRadius: "2.5px" }}
        />
        <span>{__(`settings.lang.${locale}`)}</span>
      </button>
    );

  const wrapperClass =
    variant === "profile"
      ? "language-dropdown-wrapper language-dropdown-wrapper--profile"
      : variant === "mobile-sidebar"
      ? "language-dropdown-wrapper language-dropdown-wrapper--mobile-sidebar"
      : "language-dropdown-wrapper";

  const dropdownAlign =
    variant === "profile" || variant === "mobile-sidebar" ? "left" : "right";

  return (
    <BaseDropdown
      trigger={triggerButton}
      className={wrapperClass}
      align={dropdownAlign}
    >
      {({ closeDropdown }) =>
        languages.map((lang) => {
          const ItemFlag = LANG_FLAGS[lang];
          return (
            <button
              key={lang}
              className={`base-dropdown__item ${
                locale === lang ? "active" : ""
              }`}
              onClick={() => {
                dispatch(changeLocale({ locale: lang }));
                closeDropdown();
              }}
            >
              <ItemFlag
                className="language-dropdown__flag"
                style={{ borderRadius: "2.5px" }}
              />
              <span>{__(`settings.lang.${lang}`)}</span>
            </button>
          );
        })
      }
    </BaseDropdown>
  );
};

export default LanguageDropdown;
